import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export const NaverMap = () => {
  const mapElement = useRef(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${process.env.REACT_APP_NAVER_MAP_CLIENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    script.addEventListener("load", () => {
      const { naver } = window as any;
      if (!mapElement.current || !naver) return;

      // Get from query parameters
      const lat = searchParams.get("lat");
      const lng = searchParams.get("lng");
      const message = searchParams.get("msg");

      // Guard clause
      if (!lat || !lng) {
        return navigate("/");
      }

      var map = new naver.maps.Map(mapElement.current, {
        center: new naver.maps.LatLng(Number(lat), Number(lng)),
        zoom: 18,
        draggable: false, // 드래그 비활성화
        scrollWheel: false, // 마우스 휠 줌 비활성화
        pinchZoom: false, // 모바일 핀치 줌 비활성화
        zoomControl: false, // 줌 컨트롤 UI 숨김
        keyboardShortcuts: false, // 키보드 + / - 줌 비활성화
        disableDoubleClickZoom: true, // 더블클릭 줌 비활성화
      });

      var marker = new naver.maps.Marker({
        position: new naver.maps.LatLng(Number(lat), Number(lng)),
        map: map,
      });

      if (message) {
        var infoWindow = new naver.maps.InfoWindow({
          content: `<div style="width:150px;text-align:center;padding:10px;">${message}</div>`,
        });

        infoWindow.open(map, marker);
      }
    });

    return () => {
      document.head.removeChild(script);
    };
  }, [navigate, searchParams]);

  return <div ref={mapElement} style={{ width: "100%", height: "100vh" }} />;
};
